import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="https://www.syntriq.in/" className="logo-link" onClick={closeMobileMenu}>
          {/* TODO: Replace with actual Syntriq logo from backend/storage */}
          <img 
            src="/logo.png" 
            alt="Syntriq Logo" 
            className="logo"
            onError={(e) => {
              // Fallback if logo not found
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <span style={{ display: 'none', fontSize: '1.5rem', fontWeight: '700', color: 'var(--primary-dark)' }}>
            Syntriq
          </span>
        </Link>
        
        {/* Hamburger Menu Button */}
        <button 
          className="hamburger-menu"
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation */}
        <nav className={`nav ${mobileMenuOpen ? 'active' : ''}`}>
          <Link to="/verify" className="nav-link" onClick={closeMobileMenu}>
            Verify Certificate
          </Link>
          <Link to="/download" className="nav-link" onClick={closeMobileMenu}>
            Download Certificate
          </Link>
          <Link to="/terms" className="nav-link" onClick={closeMobileMenu}>
            Terms & Conditions
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;